import _ from 'lodash';
import coin1 from '../../assets/images/coin-1-print.png'
import coin5 from '../../assets/images/coin-5-print.png'
import coin10 from '../../assets/images/coin-10-print.png'
import coin25 from '../../assets/images/coin-25-print.png'
import coin50 from '../../assets/images/coin-50-print.png'

class RouteControlController {
  /*@ngInject*/
  constructor(Auth, $state, User, $q, UserService, Modal, DateUtil, RouteService, $translate, BranchService, RouteDetailService, ScanService,
              ShipmentService, LocationService, $location, ngToast ,$timeout, UsersService, SetupService, RouteStopService, HoldService, $rootScope, 
              DataCounter, Sound, Configs, $scope, FetchReactData, $window,AutomatedRoutingStopsService, TransactionService) {

    this.BranchService = BranchService;
    this.RouteDetailService = RouteDetailService;
    this.RouteService = RouteService;
    this.ScanService = ScanService;
    this.ShipmentService = ShipmentService;
    this.LocationService = LocationService;
    this.HoldService = HoldService;
    this.$q = $q;
    this.FetchReactData = FetchReactData;
    this.$window = $window;
    this.$state = $state
    this.$location = $location;
    this.User = User;
    this.UsersService = UsersService;
    this.AutomatedRoutingStopsService = AutomatedRoutingStopsService;
    this.ngToast = ngToast;
    this.$translate = $translate;
    this.$timeout = $timeout;
    this.Modal = Modal;
    this.toggleSelect = true;
    this.SetupService = SetupService;
    this.RouteStopService = RouteStopService;
    this.DateUtil = DateUtil;
    this.$rootScope = $rootScope;
    this.DataCounter = DataCounter;
    this.Configs = Configs;
    this.Sound = Sound;
    this.TransactionService = TransactionService;
    this.branchName = '';
    this.hasAutoRoutingPermission = false;
    this.autoRouteLoading = false;
    this.branches = [];
    this.model = {
      branch: this.User.getUser().branchId,
      date: '',
      receiverMail: ''
    };
    this.selectedRouteArr = [];
    this.allRoutes = [];
    this.releasingRoutes = false;
    this.releaseRouteErrors = [];
    this.branch = '';

    this.shouldDisableBranch = false;
    this.today = moment().hour(0).minutes(0).second(0).toDate();

    this.days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    this.routes = [];
    this.loading = false;
    this.hasACL = {};
    this.hasPermission = "";
    this.routeDetails = [];
    this.routePrefix = '';
    this.selectedRoutes = [];
    this.isRouteTransfered = false;
    this.routeStopTransferedData = "";
    this.stopTransferredMessage = "";
    this.isPreviousVaultDate = false;
    this.model.loading = true;
    this.holdCount = 0;
    this.$rootScope.$broadcast('routeChange', '/app/routeControl');
    this.routeObj = {};
    this.branchDetails = "";
    this.loadShipmentList = false;
    this.printItemList = [
      {
        label: this.$translate.instant('navbar.routeSheet_title'),
        value: 'routeSheet'
      },
      {
        label: this.$translate.instant('shipmentBatch.manifest'),
        value: 'deliveryManifest'
      },
      {
        label: this.$translate.instant('shipmentBatch.manifestAll'),
        value: 'deliveryManifestAll' 
      },
      {
        label: this.$translate.instant('shipmentBatch.delivery_manifest_combined'),
        value: 'deliveryManifestCombined'
      },
      {
        label: this.$translate.instant('routeControl.coin_report'),
        value: 'coinReport'
      }
    ]
    this.cloneStopTransferValue = '';
    this.isFromRouteIsCheckedOut = false;
    this.isEmailSending = false;

    this.$scope = $scope;
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    [
      'route_control'
    ].forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey)
      this.hasACL[permissionKey] = {};

      if (this.acl[permissionKey] && this.acl[permissionKey].length > 0) {
        this.acl[permissionKey].forEach((permission) => {
          this.hasACL[permissionKey][permission] = true;
        });
      }
      this.hasPermission = this.hasACL[permissionKey];
    });
  }

  $onInit() {
    this.permissions = this.Configs.getPermissionConfig();
    this.loadPermission();
    this.moment = moment;
    // const queryParams = this.$location.search();
    const dateDefer = this.$q.defer();

    this.loading = true;
    this.model.branch = this.User.getUser().branchId;
    // queryParams.date = /\d{4}-\d{2}-\d{2}/.test(queryParams.date) ? queryParams.date : null;
    // if (queryParams.date) {
    //   const date = moment(queryParams.date).toDate();
    //   this.valutDate = moment(date).format('YYYY-MM-DD');
    //   this.minVaultDate = {
    //     minDate: this.valutDate
    //   }
    //   dateDefer.resolve(date);
    // }
    // else {
    const channel = new BroadcastChannel('app_sync_channel');

    channel.onmessage = (event) => {
      if (event.data.type === 'REACT_TAB_CLOSED') {
        this.FetchReactData.clearTransitionData();
      }
    };
    
    this.SetupService.get(this.model.branch)
    .then((setup) => {
        this.branchDetails = setup;
        this.routePrefix = setup.prefixes.route ? setup.prefixes.route[0] : '';
        const date = this.DateUtil.convertToDate(setup.currentVaultDate);
        this.valutDate = moment(date).format('YYYY-MM-DD');
        this.isCoinCheckIn = setup.coinCheckIn;
        this.minVaultDate = {
          minDate: this.valutDate
        }
        this.isCoinCheckOut = setup.coinCheckOut;
        dateDefer.resolve(date);
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal('error.' + err.data.message)
        }
      })
    // }
    dateDefer.promise
      .then((date) => {
        this.model.date = date;

        return this.loadBranches();
      })
      .then(() => {
        this.loadRoutes()
          .then(() => {
             this.autoOpenStopTransfer();
            return this.itemHoldCount();
          })
      })
      .finally(() => {
        // this.loading = false;
      });

    // this.$doc = angular.element(document)
    // this.$doc.on('keydown', this.handler.bind(this))
  }

  // $onDestroy(){
  //   this.$doc.off('keydown', this.handler)
  // }

  routeDetail(route) {
    if (this.isLoading) return;
    this.isLoading = true;
    const date = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.routeDetails(route, date, this.branchDetails.supervisorScan, ({ truck, messenger, driver, modal, guard, leaveTime, arriveTime, begMiles, endMiles }) => {
      this.RouteDetailService.routeUpdateDetails(this.model.branch, route.routeId, date, truck, messenger, driver, guard, leaveTime, arriveTime, begMiles, endMiles)
        .then((data) => {
          this.isLoading = false;
          modal.close();
        }).catch((err) => {
          this.isLoading = false;
          modal.close();
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal("error." + err.data.message);
          }
        })
    }, ({ modal }) => {
      this.isLoading = false;
      modal.close();
    })
  }

  openMessengerModal(route) {
    if (this.isLoading) return;
    this.isLoading = true;
    const date = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.routeMessenger(route, date, ({ messengerId, modal }) => {
      this.RouteDetailService.updateMessenger(this.model.branch, route.routeId, date, messengerId)
        .then((data) => {
          this.isLoading = false;
          modal.close();
          this.loadRoutes();
        }).catch((err) => {
          this.isLoading = false;
          modal.close();
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal("error." + err.data.message);
          }
        });
    }, ({ modal }) => {
      this.isLoading = false;
      modal.close();
    });
  }

  loadBranches() {
    this.branches = [this.User.getUser().branchId];
    return this.$q.when();

    // return this.BranchService.all(null, 0, 100)
    //   .then((data) => {
    // 		this.branches = data.results.map((branch) => {
    //       return branch.id;
    //     })
    // 	})
    // 	.catch((err) => {
    // 		this.error = err.message
    // 	})
    //   .finally(() => {
    //     this.loading = false
    //   })
  }

  generateSearchObj() {
    const day = this.model.date.getDay();

    if (!day === undefined) {
      return null;
    }

    return {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          },
          {
            field: 'defRoute' + this.days[day] + 'Id',
            condition: '!=',
            data: null
          }
        ],
        operator: 'AND'
      }
    };
  }

  loadRoutes() {
    this.loading = true;
    const searchObj = this.generateSearchObj();
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    if (!searchObj) {
      return;
    }

    const defer = this.$q.defer();
    this.BranchService.getReleaseRoutes(this.model.branch, formattedDate, this.isCoinCheckOut)
      .then((res) => {
        this.selectedRouteArr = [];
        this.selectedRoutes = [];
        // const routes = res.filter(route => (route.routeDetailId) || (!route.routeDetailId && (route.totalShipments > 0 || route.stops > 0)));
        this.allRoutes = _.orderBy(res, [(route) => this.isUnassignedRoute(route), 'totalShipments', 'routeName'], ['asc', 'desc', 'asc']);
        this.allRoutes.forEach((route) => this.handleRouteMileage(route));
        this.routes = this.allRoutes.filter((data) => {
          return !data.isCheckedIn
        })
      })
      .then(() => {
        const date = moment(this.model.date).format('YYYY-MM-DD');
        this.isPreviousVaultDate = date < this.valutDate;
        if (this.isPreviousVaultDate) {
          this.model.checkedInRoute = true;
          this.routes = this.allRoutes;
        }
        else this.model.checkedInRoute = false;
        defer.resolve();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
    return defer.promise;
  }

  resetData() {
    this.selectedRouteArr = [];
    this.selectedRoutes = [];
    this.toggleSelect = false;
    this.clear();
    this.toggleAllRouteSelection();
  }

  clear() {
    this.routeStopTransferedData = "";
    this.stopTransferredMessage = "";
  }

  loadData() {
    this.loading = true;
    const searchObj = this.generateSearchObj();
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');

    return this.BranchService.getReleaseRoutes(this.model.branch, formattedDate, this.isCoinCheckOut)
      .then((res) => {
        this.resetData();
        // const routes = res.filter(route => route.routeDetailId || !route.routeDetailId && (route.totalShipments > 0 || route.stops > 0));
        this.allRoutes = _.orderBy(res, [(route) => this.isUnassignedRoute(route), 'totalShipments', 'routeName'], ['asc', 'desc', 'asc']);
        this.allRoutes.forEach((route) => this.handleRouteMileage(route));
        this.loading = false;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.cloneStopTransferValue = '';
      })
  }

  editRoute(route) {
    const day = this.model.date.getDay();

    // this.$location.search('branch', this.model.branch)
    // this.$location.search('date', moment(this.model.date).format('YYYY-MM-DD'));

    if (!route.isCheckedOut && this.permissions &&this.permissions.hasSettingsPermission) {
      setTimeout(() => {
        this.$state.go('routes.edit', {
          id: route.routeId,
          day: this.days[day]
        });
      }, 200);
    }
    else {
      const obj = {
        routeId: route.routeId,
        vaultDate: moment(this.model.date).format('YYYY-MM-DD') + 'T00:00:00.000Z',
        isRedirected: true
      }
      this.DataCounter.setData(obj);
      this.$location.url('/app/branch-management/routes');
    }
  }

  toggleAllRouteSelection() {
    this.selectedRouteArr = [];
    this.routes.forEach((route) => {
      route.isSelected = this.toggleSelect
      this.selectedRoute(route.isSelected, route)
    });
    this.toggleSelect = !this.toggleSelect
  }

  executeReleaseRoutes(routes) {
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');

    routes.forEach((route) => {
      route.status = 'processing';
    });

    return routes.reduce((p, route) => {
      const nextIteration = this.$q.defer();

      p.then(() => {
        this.RouteService.releaseRoute(route.routeId, formattedDate, this.model.branch, 'route_control')
          .then((res) => {
            if (res.status) {
              route.isReleased = true;
            }
          })
          .then(() => {
            route.status = 'success';
            route.isReleased = true;
            this.Sound.playSuccessBeep("#success_beep");
          })
          .catch((err) => {
            this.Sound.PlayErrorBeep("#scanner_beep");
            this.error = JSON.parse(err.data.message);
            route.status = 'error';
            if ((this.error.message == 'E_ROUTEDETAIL_DISABLED_MULTICHECKOUT') && (this.error.errorCode == '90000')) {
              this.releaseRouteErrors[route.routeId] = {
                errorCode: this.error.errorCode,
                message: this.$translate.instant('error.disabled_multi_checkout')
              }
            }
            else {
              this.releaseRouteErrors[route.routeId] = this.error;
            }
          })
          .finally(() => {
            nextIteration.resolve();
          });
      });

      return nextIteration.promise;
    }, this.$q.when())
      .finally(() => {
        this.$timeout(() => {
          routes.forEach((route) => {
            route.status = '';
          });
        }, 3000);
      });
  }

  releaseRoute(route) {
    this.executeReleaseRoutes([route])
      .then(() => {
        return this.loadRoutes();
      });
  }

  printSheet(route) {
    if (this.isPrintLoading) return;
    this.isPrintLoading = true;
    this.branchName = this.User.getUser().branch.description;
    const url = this.$state.href('print', {
      prefix: this.routePrefix,
      route: route.routeId,
      date: moment(this.model.date).format('YYYY-MM-DD'),
      branch: this.branchName,
    });
    setTimeout(() => {
      this.isPrintLoading = false;
      window.open(url, '_blank');
    }, 1000);
  }

  printCoin(route) {
    if (this.isPrintCoinLoading) return;
    this.isPrintCoinLoading = true;
    const url = this.$state.href('coinPullReportPrint', {
      route: route.routeId,
      date: moment(this.model.date).format('YYYY-MM-DD'),
      branch: this.model.branch
    });

    setTimeout(() => {
      this.isPrintCoinLoading = false;
      window.open(url, '_blank');
    }, 1000);
  }

  selectedRoute(event, route) {
    let isChecked = (event && event.target) ? event.target.checked : event;
    this.routeDetails = [];
    if (isChecked) {
      this.selectedRouteArr.push(route.routeId)
      this.selectedRoutes.push(route.isCheckedIn)
      this.isFromRouteIsCheckedOut = this.selectedRoutes[0];
    } else {
      const index = this.selectedRouteArr.indexOf(route.routeId);
      this.selectedRouteArr.splice(index, 1);
      this.selectedRoutes.splice(index, 1);
    }
    this.isRouteCheckedIn = _.includes(this.selectedRoutes, 1)
    this.checkReleasedRoute();
    this.isRouteReleased = this.routeDetails.filter(obj => !obj.lastReleasedAt)
  }

  releaseRoutes() {
    const selectedRoutes = this.routes
      .filter((route) => route.isSelected);

    if (!selectedRoutes || !selectedRoutes.length) {
      return;
    }

    this.releasingRoutes = true;

    this.executeReleaseRoutes(selectedRoutes)
      .then(() => {
        this.ngToast.create({
          className: 'success',
          content: this.$translate.instant('routeControl.routesReleasedSuccessfully', { routeName: '' })
        });
        return this.loadRoutes();
      })
      .catch(() => {
        this.ngToast.create({
          className: 'danger',
          content: this.$translate.instant('routeControl.routesReleaseFailed', { routeName: '' })
        });
      })
      .finally(() => {
        this.releasingRoutes = false;
      });
  }

  printSheets() {
    if (this.isPrintSheetLoading) return;
    let routes = this.routes.filter((route, i) => route.isSelected)
    if (!routes.length) return;
    this.isPrintSheetLoading = true;
    routes.forEach((route, i) => {
      const url = this.$state.href('print', {
        route: route.routeId,
        date: moment(this.model.date).format('YYYY-MM-DD'),
        branch: this.model.branch
      });
      setTimeout(() => {
        if (routes.length == i + 1) {
          this.isPrintSheetLoading = false
        };
        if (url) {
          window.open(url, '_blank');
        }
      }, 1000);

    });
  }

  printCoins() {
    if (this.isPrintCoinsLoading) return;
    let routes = this.routes.filter((route, i) => route.isSelected)
    if (!routes.length) return;
    this.isPrintCoinsLoading = true;
    routes.forEach((route, i) => {
      const url = this.$state.href('coinPullReportPrint', {
        route: route.routeId,
        date: moment(this.model.date).format('YYYY-MM-DD'),
        branch: this.model.branch
      });
      setTimeout(() => {
        if (routes.length == i + 1) {
          this.isPrintCoinsLoading = false
        };
        if (url) {
          window.open(url, '_blank');
        }
      }, 1000);
    });
  }

  showCheckedInRoutes(event) {
    if (event.target.checked) {
      this.routes = this.allRoutes;
    }
    else {
      this.routes = this.allRoutes.filter((res) => {
        return !res.isCheckedIn
      })
    }
  }

  checkReleasedRoute() {
    this.selectedRouteArr.map((data) => {
      const routes = _.find(this.allRoutes, { 'routeId': data })
      this.routeDetails.push(routes);
    })
  }

  // handler(e) {
  //   if (e.keyCode === 13) {
  //     this.loadRoutes()
  //   }
  // }

  // $scope.$on('$destroy',function(){
  //   $doc.off('keydown', handler);
  // })

  stopTransferView(override) {
    this.routeDetails = [];
    this.cloneStopTransferValue = '';

    // pass selected date instead of vault date
    this.Modal.routeStopTransfer(this.model.date, this.model.date, this.valutDate, this.selectedRouteArr, this.model.branch, this.selectedRoutes,
                                ({ modal, transferredStops, fromRoutesData, destinationRoutesData, fromRouteId, fromRouteDate, 
                                   toRouteId, toRouteDate, $scope }) => {
      // console.log("transferredStops",transferredStops.length );
      this.cloneStopTransferValue = _.cloneDeep({transferredStops, $scope, override, fromRouteId, fromRouteDate, toRouteId, toRouteDate, modal, destinationRoutesData});
      return this.transferRouteStops(transferredStops, $scope, override, fromRouteId, fromRouteDate, toRouteId, toRouteDate, modal, destinationRoutesData)
    }, ({ modal, needsRefresh, totalTransferredStops, totalTransferredShipments, requireThrow }) => {
      modal.close();
      if (needsRefresh) {
        this.loadRoutes().then(() => {
          this.showStopTransferredMessage(totalTransferredStops, totalTransferredShipments, requireThrow);
        });
      }
    })
  }

  transferRouteStops(transferredStops, $scope, override, fromRouteId, fromRouteDate, toRouteId, toRouteDate, modal, destinationRoutesData) {
    let selectedRoutes = [], totalTransferredStops = 0, totalTransferredShipments = 0;

    const destinationRouteSequence = (destinationRoutesData || []).map((stop) => ({
      routeId: toRouteId,
      routeDate: toRouteDate,
      locationId: stop.locationId
    }));

    this.updateStopsAndShipments(transferredStops, $scope, override, destinationRouteSequence)
      .then((data) => {
        if (data && data.status !== false) {
          let requireThrow = data.requireThrow;

          selectedRoutes.push(
            {
              routeId: fromRouteId,
              date: fromRouteDate,
            },
            {
              routeId: toRouteId,
              date: toRouteDate,
            })

          transferredStops.forEach((t) => {
            t.shipmentInfo.forEach((s) => {
              if (s.trackingId) totalTransferredShipments++;
              else if (!s.trackingId) totalTransferredStops++;
            })
          })

          return this.routeStopTransfer(selectedRoutes, $scope)
            .then(() => {
              modal.close();
              $scope.model.isUpdating = false;
              return this.loadRoutes()
                .then(() => {
                  this.showStopTransferredMessage(totalTransferredStops, totalTransferredShipments, requireThrow);
                })
            })
        }
        else {
          $scope.model.isUpdating = false;
        }
      })
  }

  showStopTransferredMessage(totalTransferredStops, totalTransferredShipments, requireThrow) {
    if ((!totalTransferredStops || totalTransferredStops === 0) && (!totalTransferredShipments || totalTransferredShipments === 0)) return;

    setTimeout(() => {

      if (requireThrow && !this.isFromRouteIsCheckedOut && totalTransferredShipments > 0 && totalTransferredStops === 0) {
        this.stopTransferredMessage = this.$translate.instant('routeControl.StopTransferredMessage', { totalStops: totalTransferredShipments });
      }
      else if (totalTransferredShipments > 0 && totalTransferredStops === 0) {
        this.stopTransferredMessage = `<b> ${totalTransferredShipments} </b> ` + this.$translate.instant('routeControl.shipmentTransferred');
      }
      else if (totalTransferredStops > 0 && totalTransferredShipments === 0) {
        this.stopTransferredMessage = this.$translate.instant('routeControl.stops_transferred', { totalStops: totalTransferredStops })
      }
      else if (totalTransferredStops > 0 && totalTransferredShipments > 0 && !requireThrow && !this.isFromRouteIsCheckedOut) {
        this.stopTransferredMessage = this.$translate.instant('routeControl.stops_transferred', { totalStops: totalTransferredStops }) + ',' +
          `<b> ${totalTransferredShipments} </b> ` + this.$translate.instant('routeControl.shipmentTransferred');
      }
      else if (totalTransferredStops > 0 && (totalTransferredShipments > 0 && requireThrow && !this.isFromRouteIsCheckedOut)) {
        this.stopTransferredMessage = this.$translate.instant('routeControl.stops_transferred', { totalStops: totalTransferredStops }) + ',' +
          this.$translate.instant('routeControl.StopTransferredMessage', { totalStops: totalTransferredShipments });
      }
 
      this.Modal.confirm({
        header: this.$translate.instant('successModal.title'),
        message: this.$translate.instant(this.stopTransferredMessage),
        callback: (({
          modal
        }) => {
          if (requireThrow && totalTransferredShipments > 0) this.$state.go('routeThrow');
          this.isFromRouteIsCheckedOut = false;
          modal.close();
        }),
        negative: (({
          modal,
        }) => {
          modal.close();
          this.isFromRouteIsCheckedOut = false;
        }),
        buttons: (requireThrow && totalTransferredShipments > 0) ? ['routeControl.route_throw', 'common.cancel'] : ['common.ok', 'common.cancel'],
        type: 'success'
      })
    }, 500);
  }

  routeStopTransfer(routes, $scope) {
    const defer = this.$q.defer();
    this.RouteService.routeStopTransfered(routes, this.model.branch)
      .then((data) => {
        // this.loadRoutes();
        // modal.close();
        defer.resolve();
      })
      .catch((err) => {
        // this.selectedRouteArr = [];
        $scope.model.isUpdating = false;
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal('error.' + err.data.message);
        }
        defer.reject(err);
      })
    return defer.promise;
  }

  updateStopsAndShipments(transferredStopsData, $scope, override, destinationRouteSequence) {
    const defer = this.$q.defer();
    return this.RouteService.updateStopsAndShipments(transferredStopsData, transferredStopsData, this.model.branch, override, destinationRouteSequence)
      .then((data) => {
        if (data.status === true) {
          this.routeStopTransferedData = data.results;
          defer.resolve(this.routeStopTransferedData);
        }
        else {
          if (data.message === '94291') {
            this.Modal.confirm({
              header: this.$translate.instant('errorModal.title'),
              message: this.$translate.instant('error.' + data.message),
              callback: (({
                modal
              }) => {
                const val = this.cloneStopTransferValue;
                $scope.model.isUpdating = true;
                this.transferRouteStops(data.remainingStops, $scope, true, val.fromRouteId, val.fromRouteDate, val.toRouteId, val.toRouteDate, val.modal, val.destinationRoutesData)
                modal.close();
              }),
              negative: (({
                modal,
              }) => {
                modal.close();
              }),
              buttons: ['checkin.override', 'common.cancel'],
              type: 'danger'
            })
          }
          else {
            return this.Modal.errorModal('error.' + data.message);
          }
          defer.resolve(data);
        }
        $scope.model.isUpdating = false;
        return defer.promise;
      })
  }

  loadSequence(route) {
    this.Modal.routeSequenceModal(this.model.date, route.routeId, this.model.branch, this.branchDetails, ({ modal, routeSequence }) => {
      this.RouteStopService.updateRouteStop(routeSequence, this.model.branch) // update route Sequence
        .then((data) => {
          this.refreshRouteErt([route.routeId]);
          if (!route.routeTransfered) {
            const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
            return this.routeStopTransfer([{ routeId: route.routeId, date: formattedDate }])
              .then(() => {
                modal.close();
                this.loadRoutes();
              })
          }
          else {
            modal.close();
          }
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal('error.' + err.data.message);
          }
        })
    }, ({ modal }) => {
      modal.close();
    })
  }

  handleRouteMileage(route) {
    const mileageData = route.estimatedRouteMilage;
    if (!mileageData) return;

    let activeRoute = null;
    if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.ActiveRoutes && mileageData.routeAnalysis.ActiveRoutes.length > 0) {
      activeRoute = mileageData.routeAnalysis.ActiveRoutes[0];
    }

    let formattedTime = 'N/A';
    let totalDistance = 'N/A';

    if (activeRoute && activeRoute.Summary) {
      formattedTime = this.DateUtil.convertToTimeFormat(activeRoute.Summary.TotalTimeByHours);
      totalDistance = activeRoute.Summary.DistanceMiles;
    } else if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.routesSummary) {
      totalDistance = mileageData.routeAnalysis.routesSummary.TotalFleetDistanceMiles;
    } else if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.OverallSummary) {
      // Fallback for old format
      formattedTime = mileageData.routeAnalysis.OverallSummary.TotalTimeInService || this.DateUtil.convertToTimeFormat(mileageData.routeAnalysis.OverallSummary.TotalDurationHours);
      totalDistance = mileageData.routeAnalysis.OverallSummary.TotalDistanceMiles;
    }

    if (mileageData && mileageData.routeAnalysis) {
      mileageData.routeAnalysis.OverallSummary = {
        TotalTimeInService: formattedTime,
        TotalDistanceMiles: totalDistance
      };
    }
  }

  refreshRouteErt(routeIds) {
    const date = moment(this.model.date).format('YYYY-MM-DD');
    return this.AutomatedRoutingStopsService.getRouteEstimatedReturnTimes(routeIds, date)
      .then((res) => {
        const ertMap = (res && res.results) || {};
        this.allRoutes.forEach((r) => {
          if (Object.prototype.hasOwnProperty.call(ertMap, r.routeId)) {
            const ertData = ertMap[r.routeId];
            r.estimatedReturnTime = ertData && ertData.estimatedReturnTime || null;
            r.estimatedRouteMilage = ertData && ertData.estimatedRouteMilage || null;
            this.handleRouteMileage(r);
          }
        });
      })
      .catch((err) => console.log(err));
  }
  
  itemHoldSearchObj() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          },
          {
            field: 'status',
            condition: '=',
            data: 'ON_HOLD'
          }
        ],
        operator: 'AND'
      }
    };
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  itemHoldCount() {
    this.model.loading = true;
    const searchObj = this.itemHoldSearchObj();
    this.HoldService.holdItemCount(searchObj)
      .then((data) => {
        this.holdCount = data.total;
        this.model.loading = false;
      })
      .catch((err) => {
        console.log(err);
      })
  }

  holdShipmentList(data) {
    const date = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.holdShipmentModal(data.routeId, date, data.branchId, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    })
  }

  remainingToThrowShipments(route) { // show remaining throw shipments
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.remainingToThrow(route.routeId, formattedDate, this.model.date, route.branchId, this.isCoinCheckOut, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    })
  }

  remainingToPackShipments(route) { // show remaining to pack shipments
    const date = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.remainingToPack(route.routeId, date, route.branchId, this.isCoinCheckOut, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    })
  }

  redirectToCheckInScreen(route) {
    return this.$state.go('checkin');
  }

  openAdHocCheckinModal() {
    const unassignedRouteId = this.branchDetails && this.branchDetails.unassignedRouteId;

    if (!unassignedRouteId) {
      return this.Modal.errorModal(this.$translate.instant('routeControl.adHocCheckinNoUnassignedRoute'));
    }

    const setupMissing = !this.branchDetails.defaultWindowId || !this.branchDetails.defaultToTankerId;
    if (setupMissing) {
      return this.Modal.errorModal(this.$translate.instant('routeControl.adHocCheckinSetupMissing'));
    }

    this.Modal.checkedInAdHocCheckin({
      branchId: this.model.branch,
      windowId: this.branchDetails.defaultWindowId,
      routeId: unassignedRouteId,
      date: this.model.date,
      supervisorScan: false,
      branchVaultDate: this.model.date,
      cancelSupervisorChallenge: true
    }, ({ modal, $scope }) => {
      $scope.bag.branchTimeZone = this.branchDetails && this.branchDetails.timezone;
      $scope.bag.vaultDate = moment(this.model.date).format('YYYY-MM-DD');
      // Show supervisor challenge on save, like other supervisor-gated actions
      this.Modal.confirmSupervisor('ad-hoc-checkin', null, ({ modal: supModal, supId }) => {
        supModal.close();
        const pickupTimeZone =  moment.tz(
                      `${moment($scope.bag.pickupDate).format('YYYY-MM-DD')} ${$scope.bag.pickupTime}`,
                      'YYYY-MM-DD HH:mm:ss',
                      $scope.bag.branchTimeZone
                    ).utc().format()

        const payload = {
          branchId: this.model.branch || $scope.bag.branchId,
          trackingId: $scope.bag.trackingId,
          routeId: $scope.bag.routeId,
          date: pickupTimeZone,
          windowId: this.branchDetails.defaultWindowId,
          toTankerId: this.branchDetails.defaultToTankerId,
          fromTankerId: this.branchDetails.defaultFromTankerId,
          amount: $scope.bag.amount || 0,
          qty: $scope.bag.qty || 1,
          shiptypeId: $scope.bag.shiptypeId,
          fromLocationId: $scope.bag.fromLocationId.Value || $scope.bag.fromLocationId,
          toLocationId: $scope.bag.toLocationId.Value || $scope.bag.toLocationId,
          performedByUserId: this.User.getUser().id
        };

        this.ShipmentService.adhocCheckIn(payload)
          .then((res) => {
            this.Sound.playSuccessBeep("#success_beep");
            modal.close();
            return this.loadRoutes();
          })
          .catch((err) => {
            console.error('[AdHocCheckin] error =>', err);
            $scope.loading = false;
            const msg = err && err.data && (err.data.message || err.data.error || JSON.stringify(err.data));
            return this.Modal.errorModal(msg ? 'error.' + msg : 'An unexpected error occurred.');
          });
      }, ({ modal: supModal }) => {
        supModal.close();
        $scope.loading = false; // supervisor cancelled — re-enable the add-bag form
      });
    }, ({ modal }) => {
      if (modal) modal.close();
    });
  }

  // redirect to item hold screen
  redirectToItemHold() {
    return this.$state.go('branchManagement.itemHolds');
  }

  // if route exceed liabilityLimit. User will redirect from checkOut screen and User is presented with "Route Transfer Modal"
  autoOpenStopTransfer() {
    this.routeObj = this.DataCounter.getData();

    if (this.routeObj && this.routeObj.isRedirected) {
      const route = this.routes.find(data => data['routeId'].toUpperCase() === this.routeObj.routeId);

      if (route) {
        // this.routes.forEach((route) => {
        // if (route.routeId.toUpperCase() === this.routeObj.routeId) {
        route.isSelected = true;
        this.selectedRoute(route.isSelected, route);
        // }
        // });
        setTimeout(() => {
          this.stopTransferView(false);
          this.resetFilterData();
        }, 1500)
      }
      else {
        const errorMessage = this.$translate.instant('routeControl.not_found', {
          routeId: this.routeObj.routeId
        })
        setTimeout(() => {
          this.Modal.errorModal(errorMessage);
          this.resetFilterData();
        }, 1500)
      }
    }
  }

  resetFilterData() {
    if (this.routeObj && this.routeObj.isRedirected) {
      this.routeObj.isRedirected = false;
      this.routeObj = this.DataCounter.setData();
    }
  }

  shipmentListModal(route) {
    if (this.loadShipmentList) return;
    this.loadShipmentList = true;
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.shipmentList(route.routeId, formattedDate, this.branchDetails.coinCheckOut, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
      this.loadShipmentList = false;
    })
  }

  routeStopListModal(route) {
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.routeStopList(route.routeId, formattedDate, this.model.branch, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
        if (modal) modal.close();
    })
  }

  goToCancelledShipmentTab() {
    this.$state.go('branchManagement.cancelledShipments');
  }

  generateManifest(routeDetails, selectPrintOption) {
    // For email options, validate email first
    if (selectPrintOption.startsWith('email')) {
        if (!routeDetails.receiverMail) {
            return this.ngToast.create({
                className: 'danger',
                content: this.$translate.instant('common.enter_valid_email')
            });
        }
    }

    if (selectPrintOption === 'routeSheet') return this.printSheet(routeDetails);
    if (selectPrintOption === 'deliveryManifest') return this.printBatch(routeDetails);
    if (selectPrintOption === 'coinReport') return this.printCoin(routeDetails);
    if (selectPrintOption === 'deliveryManifestAll') return this.printManifestAll(routeDetails);
    if (selectPrintOption === 'deliveryManifestCombined') return this.printDeliveryManifestCombined(routeDetails);
    if (selectPrintOption === 'emailDeliveryManifest') return this.emailManifest(routeDetails, 'printBatch');
    if (selectPrintOption === 'emailDeliveryManifestAll') return this.emailManifest(routeDetails, 'deliveryManifestAll');
    if (selectPrintOption === 'emailDeliveryManifestCombined') return this.emailManifest(routeDetails, 'deliveryManifestCombined');
    if(selectPrintOption === 'emailRouteSheet') return this.emailManifest(routeDetails, 'emailRouteSheet');
  }

  printManifestAll(routeDetails) {
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    const url = this.$state.href('deliveryManifestAll');

    window.w = window.open(url, '_blank');
    window.w.printData = {
      routeId: routeDetails.routeId,
      routeDate: formattedDate
    }
  }

  printBatch(routeDetails) {
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    
    this.ShipmentService.getShipmentsOnRoute(routeDetails.routeId, formattedDate, this.isCoinCheckOut)
      .then((data) => {
        if (data.results.length) {
          let url = this.$state.href('printBatch');
          window.w = window.open(url, '_blank');
          window.w.printData = {
            trackingIds: data.results.map(d => d.trackingId)
          }
        }
        else {
          const errorMessage = this.$translate.instant('routeControl.no_shipment_found', {
            routeId: routeDetails.routeId
          })
          this.Modal.errorModal(errorMessage);
        }
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          const errorMessage = this.$translate.instant('routeControl.no_shipment_found', {
            routeId: routeDetails.routeId
          })
          this.Modal.errorModal(errorMessage);
        }
      })
  }

  pendingCancelShipmentModal(route) {
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.pendingCancelShipments(route.branchId, route.routeId, formattedDate, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  goToRouteProgress(data) {
    document.getElementById('routeProgress').blur();
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    const obj = {
        routeId: data.routeId,
        vaultDate: formattedDate + 'T00:00:00.000Z',
        isRedirected: true
    }
    this.DataCounter.setData(obj);
    this.$state.go('routeProgress');
  }
  
  showRouteServiceTickets(route) {
    this.Modal.routeServiceTicketsModal({
      routeId: route.routeId,
      branchId: this.model.branch,
      vaultDate: this.model.date,
      userId: route.messengerId
    }, () => {});
  }

  pickupDeliveryShipmentsModal(route, flagType) {
    // if(route.totalPickupsCount === 0) return;
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.pickupDeliveryShipments(route.branchId, route.routeId, formattedDate, flagType, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      modal.close();
    })
  }

  duplicateRouteStopList(data) {
    this.Modal.duplicateRouteStopList(data.routeId, data.duplicateStops, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  printDeliveryManifestCombined(routeDetails) {
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    const url = this.$state.href('deliveryManifestCombined');
    window.w = window.open(url, '_blank');
    window.w.printData = {
      routeId: routeDetails.routeId,
      routeDate: formattedDate
    }
  }

  handlePrintBatchManifest(routeDetails, formattedDate) {
    return this.ShipmentService.getShipmentsOnRoute(routeDetails.routeId, formattedDate, this.isCoinCheckOut)
      .then((data) => {
        if (data.results.length) {
          return data.results.map(d => d.trackingId);
        } else {
          const errorMessage = this.$translate.instant('routeControl.no_shipment_found', {
            routeId: routeDetails.routeId
          });
          this.Modal.errorModal(errorMessage);
          throw new Error(errorMessage);
        }
      });
  }

  // emailManifest(routeDetails, selectPrintOption) {
  //   const deferred = this.$q.defer();
  //   const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    
  //   // Handle printBatch case first
  //   if (selectPrintOption === 'printBatch') {
  //     this.handlePrintBatchManifest(routeDetails, formattedDate)
  //       .then((trackingIds) => {
  //         routeDetails.shipments = trackingIds;
  //         return this.sendEmailManifest(routeDetails, selectPrintOption, formattedDate, true);
  //       })
  //       .then((response) => {
  //         routeDetails.isEmailSending = false;
  //         routeDetails.receiverMail = null;
  //         if (response.success) {
  //           this.Modal.confirm({
  //             header: this.$translate.instant('successModal.title'),
  //             message: this.$translate.instant('common.email_sent_success'),
  //             callback: (({ modal }) => {
  //               modal.close();
  //             }),
  //             buttons: ['common.ok'],
  //             type: 'success'
  //           });
  //         }
  //         deferred.resolve();
  //       })
  //       .catch((error) => {
  //         console.error('Error in emailManifest:', error);
  //         routeDetails.isEmailSending = false;
  //         deferred.reject(error);
  //       });
  //   } else {
  //     // Handle other manifest types
  //     this.sendEmailManifest(routeDetails, selectPrintOption, formattedDate, false)
  //       .then((response) => {
  //         routeDetails.isEmailSending = false;
  //         if (response.success) {
  //           this.Modal.confirm({
  //             header: this.$translate.instant('successModal.title'),
  //             message: this.$translate.instant('common.email_sent_success'),
  //             callback: (({ modal }) => {
  //               modal.close();
  //             }),
  //             buttons: ['common.ok'],
  //             type: 'success'
  //           });
  //         }
  //         deferred.resolve();
  //       })
  //       .catch((error) => {
  //         console.error('Error in emailManifest:', error);
  //         routeDetails.isEmailSending = false;
  //         this.Modal.errorModal(this.$translate.instant('common.email_sent_error'));
  //         deferred.reject(error);
  //       })
  //       .finally(() => {
  //         routeDetails.isEmailSending = false;
  //         routeDetails.receiverMail = null;
  //       });
  //   }

  //   return deferred.promise;
  // }

  emailManifest(routeDetails, selectPrintOption) {
    const routeId = routeDetails.routeId;
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    routeDetails.isEmailSending = true;
    let apiCall;
    switch (selectPrintOption) {
        case 'deliveryManifestCombined':
            apiCall = this.ShipmentService.deliveryManifestCombined(routeId, formattedDate)
                .then(res => {
                    const emailData = {
                        routeId: routeId,
                        vaultDate: formattedDate,
                        reportData: res.results, 
                        receiverEmail: routeDetails.receiverMail,
                        branchId: this.model.branch,
                        title: 'DeliveryManifestCombined',
                    };

                    return this.RouteService.emailManifest(routeId, emailData);
                })
                .then(() => {
                  routeDetails.isEmailSending = false;
                  routeDetails.receiverMail = null;
                    this.Modal.confirm({
                        header: this.$translate.instant('successModal.title'),
                        message: this.$translate.instant('common.email_sent_success'),
                        callback: (({ modal }) => {
                            modal.close();
                        }),
                        buttons: ['common.ok'],
                        type: 'success'
                    });
                });
            break;

        case 'deliveryManifestAll':
            apiCall = this.ShipmentService.deliveryManifestAll(routeId, formattedDate)
                .then(res => {
                    const emailData = {
                        routeId: routeId,
                        vaultDate: formattedDate,
                        reportData: res.results,
                        receiverEmail: routeDetails.receiverMail,
                        branchId: this.model.branch,
                        title: 'DeliveryManifestAll',
                    };

                    return this.RouteService.emailManifest(routeId, emailData);
                })
                .then(() => {
                  routeDetails.isEmailSending = false;
                  routeDetails.receiverMail = null;
                    this.Modal.confirm({
                        header: this.$translate.instant('successModal.title'),
                        message: this.$translate.instant('common.email_sent_success'),
                        callback: (({ modal }) => {
                            modal.close();
                        }),
                        buttons: ['common.ok'],
                        type: 'success'
                    });
                });
            break;
            case 'printBatch':
              apiCall = this.ShipmentService.getShipmentsOnRoute(routeId, formattedDate, this.isCoinCheckOut)
                  .then((data) => {
                      if (data.results.length) {
                        const trackingIds = data.results.map(d => d.trackingId);
                        this.ShipmentService.batchRecords(trackingIds)
                        .then(res => {
                            const emailData = {
                                routeId: routeId,
                                vaultDate: formattedDate,
                                reportData: res.results,
                                receiverEmail: routeDetails.receiverMail,
                                branchId: this.model.branch,
                                title: 'DeliveryManifest',
                            };
                            this.RouteService.emailManifest(routeId, emailData)
                            .then(() => {
                              routeDetails.isEmailSending = false;
                              routeDetails.receiverMail = null;
                                this.Modal.confirm({
                                    header: this.$translate.instant('successModal.title'),
                                    message: this.$translate.instant('common.email_sent_success'),
                                    callback: (({ modal }) => {
                                        modal.close();
                                    }),
                                    buttons: ['common.ok'],
                                    type: 'success'
                                });
                            });
                        })
                      }
                    })

              break;
        case 'emailRouteSheet':
            let payload = {
                routeId: routeId,
                vaultDate: formattedDate,
                receiverEmails: routeDetails.receiverMail,
                branchId: this.model.branch
            }
            apiCall = this.RouteService.emailRouteSheet(routeId,payload)
                .then(() => {
                  routeDetails.isEmailSending = false;
                  routeDetails.receiverMail = null;
                    this.Modal.confirm({
                        header: this.$translate.instant('successModal.title'),
                        message: this.$translate.instant('common.email_sent_success'),
                        callback: (({ modal }) => {
                            modal.close();
                        }),
                        buttons: ['common.ok'],
                        type: 'success'
                    });
            })
        break;
        default:
            apiCall = Promise.reject(new Error('Invalid print option'));
    }

    return apiCall.catch(error => {
        console.error('Error in emailManifest:', error);
        routeDetails.isEmailSending = false;
        routeDetails.receiverMail = null;
        this.Modal.error({
            title: this.$translate.instant('common.error'),
            message: error.message || this.$translate.instant('common.something_went_wrong')
        });
    });
}

hasValidEmails(receiverMail) {
  if (!receiverMail) return false;
  const emails = receiverMail.split(',').map(email => email.trim());

  const uniqueEmails = new Set();
  for (const email of emails) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return false; 
    }
    if (uniqueEmails.has(email)) {
      return false; 
    }
    uniqueEmails.add(email);
  }

  return true;
};

  pendingShipmentTransferModal(route) {
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.pendingShipmentTransfer(route, formattedDate, this.branchDetails.unassignedRouteId, ({ modal, message }) => {
      if (message === 'TRNASFER_CANCELLED') {
        modal.close();
        this.loadRoutes();
        this.clear();
      }
      modal.close();
    }, ({ modal }) => {
      modal.close();
    })
  }

  // sendEmailManifest(routeDetails, selectPrintOption, formattedDate, shipments) {
  //   routeDetails.isEmailSending = true;
  //   const relativeUrl = this.$state.href(selectPrintOption);
  //   const fullUrl = window.location.origin + relativeUrl;
  //   const emailData = {
  //     routeId: routeDetails.routeId,
  //     routeDate: formattedDate,
  //     receiverEmail: routeDetails.receiverMail,
  //     shipments: shipments,
  //     branchId: this.model.branch
  //   };

  //   return this.RouteService.emailManifest(routeDetails.routeId, emailData);
  // }

  // handleEmailClick(route) {
    
  //   if (this.branchDetails.fromLocation.email) {
  //       route.receiverMail = this.branchDetails.fromLocation.email;
  //   }
  // }

  isUnassignedRoute(route) {
    return route.routeId === (this.branchDetails && this.branchDetails.unassignedRouteId) && route.isSpecialRoute === 1;
  }


  goToAutoRouting(){
    this.autoRouteLoading = true;
    let routes = [];
    this.selectedRouteArr.forEach((route, i) => {
      const findRoute = this.routes.find(r => r.routeId === route && !this.isUnassignedRoute(r));
      if(findRoute){
        routes.push(findRoute);
      }
    });

    const unassignedRouteItem = this.allRoutes.find(r => this.isUnassignedRoute(r));
    if (unassignedRouteItem && !routes.find(r => r.routeId === unassignedRouteItem.routeId)) {
      routes.push(unassignedRouteItem);
    }

    this.FetchReactData.setTransitionData({
      selectedRoutes: routes,
      vaultDate: this.model.date,
      branchId: this.model.branch,
      isRedirected: true
    });
    const activeRouteSelected = routes.some(r => !this.isUnassignedRoute(r));
    if(!activeRouteSelected){
      this.Modal.errorModal('Please select at least one route which is not unassigned.');
      this.FetchReactData.clearTransitionData();
      this.autoRouteLoading = false;
      return;
    }
    this.AutomatedRoutingStopsService.assignAutomatedRoutes(routes.map((t) => t.routeId), moment(this.model.date).format("YYYY-MM-DD"), this.model.branch).then(() => {
      const baseUrl = this.$window.location.origin;
      const reactUrl = `${baseUrl}/v2/index.html#/automated-routing-control`;
      this.$window.open(reactUrl, "_blank");
    }).catch((error) => {
      console.log(error);
       this.Modal.errorModal(error.data.message || this.$translate.instant('common.something_went_wrong'));
       this.FetchReactData.clearTransitionData();
      }).finally(() => {
      this.autoRouteLoading = false;
    })
  }

  isAllowToAutoRoutingControl() {
    const config = this.Configs.getEnvironmentConfig();
    const usersString = config && config.permissions && config.permissions.automatedRoutingControl ? config.permissions.automatedRoutingControl.users : '';
    let hasConfigAutoRoutingPermission = true;
    if (usersString) {
        const userList = usersString.split(',').map(u => u.trim().toLowerCase());
        const firstName = this.User.getUser().firstName ? this.User.getUser().firstName.trim().toLowerCase() : '';
        const lastName = this.User.getUser().lastName ? this.User.getUser().lastName.trim().toLowerCase() : '';
        
        const nameFormat1 = firstName + ' ' + lastName;
        const nameFormat2 = lastName + ' ' + firstName;
        hasConfigAutoRoutingPermission = userList.includes(nameFormat1) || userList.includes(nameFormat2);
      }
    return hasConfigAutoRoutingPermission;
  }
}

export default RouteControlController;



// WEBPACK FOOTER //
// ./client/app/components/route_control/route_control.controller.js